//#region src/extensions/text-align-extension/text-align-enum.ts
var e = /* @__PURE__ */ function(e) {
	return e.Left = "left", e.Right = "right", e.Center = "center", e.Justify = "justify", e;
}({});
//#endregion
export { e as TextAlignEnum };
